<template>
    <div class="text-center">
        <span class="d-block error-page__title mb-0 font-weight-light">404</span>
        <span class="d-block mb-2 error-page__subtitle font-weight-bold">{{ $t('pageNotFound') }}</span>
        <span class="d-block mb-5 error-page__text text-secondary">{{ $t('textErrorPage') }}</span>
        <router-link class="btn btn-primary btn__min-width" :to="{ name: $options.ROUTES_HOME }">
            {{ $t('home') }}
        </router-link>
    </div>
</template>

<script>
import { ROUTES_HOME } from '@/constants/routes';

export default {
    ROUTES_HOME
};
</script>
